import React from 'react';
import styled from 'styled-components';
import { Title } from './ui';

const SectionHeaderBarContainer = styled.div<{ bannerHeight: number; isCustomizedConfigurator?: boolean }>`
    text-align: center;
    position: sticky;
    top: 0px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${props => (props.isCustomizedConfigurator ? '40px 24px' : '40px 24px 10px')};
    z-index: 100;

    top: ${({ bannerHeight = 0 }) => `${80 + bannerHeight}px`};
    padding-top: 40px;
`;

type SectionHeaderBarProps = {
    text: string;
    bannerHeight?: number;
    isCustomizedConfigurator?: boolean;
};

const SectionHeaderBar = ({ text, bannerHeight, isCustomizedConfigurator }: SectionHeaderBarProps) => (
    <SectionHeaderBarContainer bannerHeight={bannerHeight} isCustomizedConfigurator={isCustomizedConfigurator}>
        <Title>{text}</Title>
    </SectionHeaderBarContainer>
);

export default SectionHeaderBar;
